import { GeneratedBizBase } from '../GeneratedBizBase';


import { Response } from '../../../src_server/response/Response';export class NotifyMessageTestService extends GeneratedBizBase{
  async isLineSettingUser(user_id: string): Promise<Response<boolean>> {
    return super.restCall<Response<boolean>>('post', '/v1/NotifyMessageTestService/getUserInfo', arguments);
  }
  async sendLineMessage(message: string,user_id: string): Promise<Response<boolean>> {
    return super.restCall<Response<boolean>>('post', '/v1/NotifyMessageTestService/sendLineMessage', arguments);
  }
}
